function getColorBrightness(rgbColor) {
  var colorValues = rgbColor.match(/[\d\.]+/g).map(Number);
  return 0.2126 * (colorValues[0] / 255) + 0.7152 * (colorValues[1] / 255) + 0.0722 * (colorValues[2] / 255);
}

function isSimilarToBackground(color) {
  var backgroundColor = 'rgb(249, 241, 231)';

  var colorBrightness = getColorBrightness(color);
  var backgroundColorBrightness = getColorBrightness(backgroundColor);

  return (backgroundColorBrightness / colorBrightness) < 1.5;
}

var SwatchColors = (function() {
  function SwatchColors() {
    this.colors = {'pink': 'rgb(252, 24, 150)','cream': 'rgb(245, 231, 211)','hydrangea': 'rgb(197, 218, 232)','butter': 'rgb(229, 220, 175)','burnt-maroon': 'rgb(133, 43, 82)','ecru': 'rgb(255, 255, 255)','sail': 'rgb(255, 255, 255)','cobblestone': 'rgb(193, 189, 186)','navy-pink': 'rgb(45, 54, 82)','heather-grey': 'rgb(193, 189, 186)','creme': 'rgb(235, 236, 233)','smoke-gray': 'rgb(77, 77, 77)','bone': 'rgb(212, 206, 190)',};

    this.images = {'cammo': 'url("//sandiegowavefc.store/cdn/shop/files/Cammo_120x.png?v=15552640628896128487")','ash': 'url("//sandiegowavefc.store/cdn/shop/files/Ash_120x.png?v=11249339667949576504")','white-grey': 'url("//sandiegowavefc.store/cdn/shop/files/whitegrey_120x.png?v=7576403576887394972")',};

    this.triggers = ['color','colour','couleur','farbe','cor',];
  }

  function setSwatchColor(swatch) {
    var swatchId = swatch.getAttribute('swatch-id');

    if (Object.keys(this.colors).includes(swatchId)) {
      swatch.style.setProperty("--background-graphic", this.colors[swatchId]);

      if (isSimilarToBackground(this.colors[swatchId])) swatch.classList.add('is-similar-to-background');
      if (getColorBrightness(this.colors[swatchId]) > 0.5) {
        swatch.style.setProperty('--tick-color', '#000');
      } else {
        swatch.style.setProperty('--tick-color', '#fff');
      }
      swatch.classList.remove('is-blank');
    }

    if (Object.keys(this.images).includes(swatchId)) {
      swatch.style.setProperty("--background-graphic", this.images[swatchId]);
      swatch.classList.add('is-image');
      swatch.classList.remove('is-blank');
    }
  }
  SwatchColors.prototype.setSwatchColor = setSwatchColor;

  return SwatchColors;
}());

const Swatches = new SwatchColors();

function VariantSwatch() {
  return Reflect.construct(HTMLElement, [], this.constructor);
}

VariantSwatch.prototype = Object.create(HTMLElement.prototype);
VariantSwatch.prototype.constructor = VariantSwatch;
Object.setPrototypeOf(VariantSwatch, HTMLElement);

VariantSwatch.prototype.connectedCallback = function() {
  Swatches.setSwatchColor(this);
};
customElements.define('variant-swatch', VariantSwatch);

export default Swatches;
